export const LibData={
    "ListAllBrands": {
        "ABB": 25,
        "Brooks": 6,
        "Comau": 9,
        "Gudel": 12,
        "HIWIN": 4,
        "KUKA": 21,
        "Lucas": 4,
        "MABI Robotic": 2,
        "SMC": 2,
        "Vansichen": 1,
        "Yaskawa Motoman": 3,
        "Zaber": 12
    },
    "ListAllAxes": {
        "1": 82,
        "2": 16,
        "3": 3
    },
    "ListAllTypes": {
        "Ext. axis": 101
    },
    "ListAllApplications": {},
    "payloadMin": 50,
    "payloadMax": 6500,
    "reachMin": 450,
    "reachMax": 20000,
    "weightMin": 30,
    "weightMax": 6440,
    "repeatabilityMin": 4.1e-05,
    "repeatabilityMax": 0.1,
    "payloadMinRobot": 1000000000.0,
    "payloadMaxRobot": 0,
    "reachMinRobot": 1000000000.0,
    "reachMaxRobot": 0,
    "weightMinRobot": 1000000000.0,
    "weightMaxRobot": 0,
    "repeatabilityMinRobot": 1000000000.0,
    "repeatabilityMaxRobot": 0,
    "DATA_ALL": {
        "ABB-IRBP-A250-D1000": {
            "MT": "E",
            "N": "ABB IRBP A250 D1000",
            "F": "ABB-IRBP-A250-D1000.robot",
            "I": "ABB-IRBP-A250-D1000-robot.png",
            "IS": "ABB-IRBP-A250-D1000.png",
            "B": "ABB",
            "M": "IRBP A250 D1000",
            "T": "Ext. axis",
            "A": 2,
            "P": 250,
            "E": 0.1
        },
        "ABB-IRBP-A500-D1000-H700": {
            "MT": "E",
            "N": "ABB IRBP A500 D1000 H700",
            "F": "ABB-IRBP-A500-D1000-H700.robot",
            "I": "ABB-IRBP-A500-D1000-H700-robot.png",
            "IS": "ABB-IRBP-A500-D1000-H700.png",
            "B": "ABB",
            "M": "IRBP A500 D1000 H700",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "E": 0.1
        },
        "ABB-IRBP-A500-D1000-H900": {
            "MT": "E",
            "N": "ABB IRBP A500 D1000 H900",
            "F": "ABB-IRBP-A500-D1000-H900.robot",
            "I": "ABB-IRBP-A500-D1000-H900-robot.png",
            "IS": "ABB-IRBP-A500-D1000-H900.png",
            "B": "ABB",
            "M": "IRBP A500 D1000 H900",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "E": 0.1
        },
        "ABB-IRBP-A500-D1450-H700": {
            "MT": "E",
            "N": "ABB IRBP A500 D1450 H700",
            "F": "ABB-IRBP-A500-D1450-H700.robot",
            "I": "ABB-IRBP-A500-D1450-H700-robot.png",
            "IS": "ABB-IRBP-A500-D1450-H700.png",
            "B": "ABB",
            "M": "IRBP A500 D1450 H700",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "E": 0.1
        },
        "ABB-IRBP-A500-D1450-H900": {
            "MT": "E",
            "N": "ABB IRBP A500 D1450 H900",
            "F": "ABB-IRBP-A500-D1450-H900.robot",
            "I": "ABB-IRBP-A500-D1450-H900-robot.png",
            "IS": "ABB-IRBP-A500-D1450-H900.png",
            "B": "ABB",
            "M": "IRBP A500 D1450 H900",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "E": 0.1
        },
        "ABB-IRBP-A750-D1000-H700": {
            "MT": "E",
            "N": "ABB IRBP A750 D1000 H700",
            "F": "ABB-IRBP-A750-D1000-H700.robot",
            "I": "ABB-IRBP-A750-D1000-H700-robot.png",
            "IS": "ABB-IRBP-A750-D1000-H700.png",
            "B": "ABB",
            "M": "IRBP A750 D1000 H700",
            "T": "Ext. axis",
            "A": 2,
            "P": 750,
            "E": 0.1
        },
        "ABB-IRBP-A750-D1000-H900": {
            "MT": "E",
            "N": "ABB IRBP A750 D1000 H900",
            "F": "ABB-IRBP-A750-D1000-H900.robot",
            "I": "ABB-IRBP-A750-D1000-H900-robot.png",
            "IS": "ABB-IRBP-A750-D1000-H900.png",
            "B": "ABB",
            "M": "IRBP A750 D1000 H900",
            "T": "Ext. axis",
            "A": 2,
            "P": 750,
            "E": 0.1
        },
        "ABB-IRBP-L300-L1250": {
            "MT": "E",
            "N": "ABB IRBP L300 L1250",
            "F": "ABB-IRBP-L300-L1250.robot",
            "I": "ABB-IRBP-L300-L1250-robot.png",
            "IS": "ABB-IRBP-L300-L1250.png",
            "B": "ABB",
            "M": "IRBP L300 L1250",
            "T": "Ext. axis",
            "A": 1,
            "P": 300,
            "E": 0.1
        },
        "ABB-IRBP-L300-L4000": {
            "MT": "E",
            "N": "ABB IRBP L300 L4000",
            "F": "ABB-IRBP-L300-L4000.robot",
            "I": "ABB-IRBP-L300-L4000-robot.png",
            "IS": "ABB-IRBP-L300-L4000.png",
            "B": "ABB",
            "M": "IRBP L300 L4000",
            "T": "Ext. axis",
            "A": 1,
            "P": 300,
            "E": 0.1
        },
        "ABB-IRBP-L600-L1250": {
            "MT": "E",
            "N": "ABB IRBP L600 L1250",
            "F": "ABB-IRBP-L600-L1250.robot",
            "I": "ABB-IRBP-L600-L1250-robot.png",
            "IS": "ABB-IRBP-L600-L1250.png",
            "B": "ABB",
            "M": "IRBP L600 L1250",
            "T": "Ext. axis",
            "A": 1,
            "P": 600,
            "E": 0.1
        },
        "ABB-IRBP-L600-L4000": {
            "MT": "E",
            "N": "ABB IRBP L600 L4000",
            "F": "ABB-IRBP-L600-L4000.robot",
            "I": "ABB-IRBP-L600-L4000-robot.png",
            "IS": "ABB-IRBP-L600-L4000.png",
            "B": "ABB",
            "M": "IRBP L600 L4000",
            "T": "Ext. axis",
            "A": 1,
            "P": 600,
            "E": 0.1
        },
        "ABB-IRBP-L1000-L1250": {
            "MT": "E",
            "N": "ABB IRBP L1000 L1250",
            "F": "ABB-IRBP-L1000-L1250.robot",
            "I": "ABB-IRBP-L1000-L1250-robot.png",
            "IS": "ABB-IRBP-L1000-L1250.png",
            "B": "ABB",
            "M": "IRBP L1000 L1250",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000,
            "E": 0.1
        },
        "ABB-IRBP-L1000-L4000": {
            "MT": "E",
            "N": "ABB IRBP L1000 L4000",
            "F": "ABB-IRBP-L1000-L4000.robot",
            "I": "ABB-IRBP-L1000-L4000-robot.png",
            "IS": "ABB-IRBP-L1000-L4000.png",
            "B": "ABB",
            "M": "IRBP L1000 L4000",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000,
            "E": 0.1
        },
        "ABB-IRBP-L2000-L1250": {
            "MT": "E",
            "N": "ABB IRBP L2000 L1250",
            "F": "ABB-IRBP-L2000-L1250.robot",
            "I": "ABB-IRBP-L2000-L1250-robot.png",
            "IS": "ABB-IRBP-L2000-L1250.png",
            "B": "ABB",
            "M": "IRBP L2000 L1250",
            "T": "Ext. axis",
            "A": 1,
            "P": 2000,
            "E": 0.1
        },
        "ABB-IRBP-L2000-L3150": {
            "MT": "E",
            "N": "ABB IRBP L2000 L3150",
            "F": "ABB-IRBP-L2000-L3150.robot",
            "I": "ABB-IRBP-L2000-L3150-robot.png",
            "IS": "ABB-IRBP-L2000-L3150.png",
            "B": "ABB",
            "M": "IRBP L2000 L3150",
            "T": "Ext. axis",
            "A": 1,
            "P": 2000,
            "E": 0.1
        },
        "ABB-IRBP-L2000-L4000": {
            "MT": "E",
            "N": "ABB IRBP L2000 L4000",
            "F": "ABB-IRBP-L2000-L4000.robot",
            "I": "ABB-IRBP-L2000-L4000-robot.png",
            "IS": "ABB-IRBP-L2000-L4000.png",
            "B": "ABB",
            "M": "IRBP L2000 L4000",
            "T": "Ext. axis",
            "A": 1,
            "P": 2000,
            "E": 0.1
        },
        "ABB-IRBT-2005-Standard-2-8m": {
            "MT": "E",
            "N": "ABB IRBT 2005 Standard 2.8m",
            "F": "ABB-IRBT-2005-Standard-2-8m.robot",
            "I": "ABB-IRBT-2005-Standard-2-8m-robot.png",
            "IS": "ABB-IRBT-2005-Standard-2-8m.png",
            "B": "ABB",
            "M": "IRBT 2005 Standard 2.8m",
            "T": "Ext. axis",
            "A": 1,
            "R": 2800,
            "P": 1200,
            "E": 0.05
        },
        "ABB-IRBT-4004-Standard-20m": {
            "MT": "E",
            "N": "ABB IRBT 4004 Standard 20m",
            "F": "ABB-IRBT-4004-Standard-20m.robot",
            "I": "ABB-IRBT-4004-Standard-20m-robot.png",
            "IS": "ABB-IRBT-4004-Standard-20m.png",
            "B": "ABB",
            "M": "IRBT 4004 Standard 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000,
            "E": 0.1
        },
        "ABB-IRBT-6004-Mirrored-20m": {
            "MT": "E",
            "N": "ABB IRBT 6004 Mirrored 20m",
            "F": "ABB-IRBT-6004-Mirrored-20m.robot",
            "I": "ABB-IRBT-6004-Mirrored-20m-robot.png",
            "IS": "ABB-IRBT-6004-Mirrored-20m.png",
            "B": "ABB",
            "M": "IRBT 6004 Mirrored 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000,
            "E": 0.1
        },
        "ABB-IRBT-6004-Standard-3-5m": {
            "MT": "E",
            "N": "ABB IRBT 6004 Standard 3.5m",
            "F": "ABB-IRBT-6004-Standard-3-5m.robot",
            "I": "ABB-IRBT-6004-Standard-3-5m-robot.png",
            "IS": "ABB-IRBT-6004-Standard-3-5m.png",
            "B": "ABB",
            "M": "IRBT 6004 Standard 3.5m",
            "T": "Ext. axis",
            "A": 1,
            "R": 3500,
            "E": 0.1
        },
        "ABB-IRBT-6004-Standard-20m": {
            "MT": "E",
            "N": "ABB IRBT 6004 Standard 20m",
            "F": "ABB-IRBT-6004-Standard-20m.robot",
            "I": "ABB-IRBT-6004-Standard-20m-robot.png",
            "IS": "ABB-IRBT-6004-Standard-20m.png",
            "B": "ABB",
            "M": "IRBT 6004 Standard 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000,
            "E": 0.1
        },
        "ABB-IRBT-7004-Mirrored-20m": {
            "MT": "E",
            "N": "ABB IRBT 7004 Mirrored 20m",
            "F": "ABB-IRBT-7004-Mirrored-20m.robot",
            "I": "ABB-IRBT-7004-Mirrored-20m-robot.png",
            "IS": "ABB-IRBT-7004-Mirrored-20m.png",
            "B": "ABB",
            "M": "IRBT 7004 Mirrored 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000,
            "E": 0.1
        },
        "ABB-IRBT-7004-Standard-4m": {
            "MT": "E",
            "N": "ABB IRBT 7004 Standard 4m",
            "F": "ABB-IRBT-7004-Standard-4m.robot",
            "I": "ABB-IRBT-7004-Standard-4m-robot.png",
            "IS": "ABB-IRBT-7004-Standard-4m.png",
            "B": "ABB",
            "M": "IRBT 7004 Standard 4m",
            "T": "Ext. axis",
            "A": 1,
            "R": 3700
        },
        "ABB-IRBT-7004-Standard-20m": {
            "MT": "E",
            "N": "ABB IRBT 7004 Standard 20m",
            "F": "ABB-IRBT-7004-Standard-20m.robot",
            "I": "ABB-IRBT-7004-Standard-20m-robot.png",
            "IS": "ABB-IRBT-7004-Standard-20m.png",
            "B": "ABB",
            "M": "IRBT 7004 Standard 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000,
            "E": 0.1
        },
        "ABB-MTD-250": {
            "MT": "E",
            "N": "ABB MTD 250",
            "F": "ABB-MTD-250.robot",
            "I": "ABB-MTD-250-robot.png",
            "IS": "ABB-MTD-250.png",
            "B": "ABB",
            "M": "MTD 250",
            "T": "Ext. axis",
            "A": 1
        },
        "Brooks-PreciseFlex-Linear-Rail-1000-90": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 1000 -90",
            "F": "Brooks-PreciseFlex-Linear-Rail-1000-90.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-1000-90-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-1000-90.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 1000 -90",
            "T": "Ext. axis",
            "A": 1,
            "W": 30,
            "E": 0.05
        },
        "Brooks-PreciseFlex-Linear-Rail-1000": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 1000",
            "F": "Brooks-PreciseFlex-Linear-Rail-1000.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-1000-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-1000.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 1000",
            "T": "Ext. axis",
            "A": 1,
            "W": 30,
            "E": 0.05
        },
        "Brooks-PreciseFlex-Linear-Rail-1500-90": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 1500 -90",
            "F": "Brooks-PreciseFlex-Linear-Rail-1500-90.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-1500-90-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-1500-90.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 1500 -90",
            "T": "Ext. axis",
            "A": 1,
            "W": 45,
            "E": 0.05
        },
        "Brooks-PreciseFlex-Linear-Rail-1500": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 1500",
            "F": "Brooks-PreciseFlex-Linear-Rail-1500.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-1500-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-1500.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 1500",
            "T": "Ext. axis",
            "A": 1,
            "W": 45,
            "E": 0.05
        },
        "Brooks-PreciseFlex-Linear-Rail-2000-90": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 2000 -90",
            "F": "Brooks-PreciseFlex-Linear-Rail-2000-90.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-2000-90-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-2000-90.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 2000 -90",
            "T": "Ext. axis",
            "A": 1,
            "W": 60,
            "E": 0.05
        },
        "Brooks-PreciseFlex-Linear-Rail-2000": {
            "MT": "E",
            "N": "Brooks PreciseFlex Linear Rail 2000",
            "F": "Brooks-PreciseFlex-Linear-Rail-2000.robot",
            "I": "Brooks-PreciseFlex-Linear-Rail-2000-robot.png",
            "IS": "Brooks-PreciseFlex-Linear-Rail-2000.png",
            "B": "Brooks",
            "M": "PreciseFlex Linear Rail 2000",
            "T": "Ext. axis",
            "A": 1,
            "W": 60,
            "E": 0.05
        },
        "Comau-MP-500": {
            "MT": "E",
            "N": "Comau MP-500",
            "F": "Comau-MP-500.robot",
            "I": "Comau-MP-500-robot.png",
            "IS": "Comau-MP-500.png",
            "B": "Comau",
            "M": "MP-500",
            "T": "Ext. axis",
            "A": 1,
            "P": 500,
            "W": 53,
            "E": 0.05
        },
        "Comau-MP-1000": {
            "MT": "E",
            "N": "Comau MP-1000",
            "F": "Comau-MP-1000.robot",
            "I": "Comau-MP-1000-robot.png",
            "IS": "Comau-MP-1000.png",
            "B": "Comau",
            "M": "MP-1000",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000,
            "W": 90,
            "E": 0.06
        },
        "Comau-MP-1250": {
            "MT": "E",
            "N": "Comau MP-1250",
            "F": "Comau-MP-1250.robot",
            "I": "Comau-MP-1250-robot.png",
            "IS": "Comau-MP-1250.png",
            "B": "Comau",
            "M": "MP-1250",
            "T": "Ext. axis",
            "A": 1,
            "P": 2500,
            "W": 290,
            "E": 0.09
        },
        "Comau-MP-2500": {
            "MT": "E",
            "N": "Comau MP-2500",
            "F": "Comau-MP-2500.robot",
            "I": "Comau-MP-2500-robot.png",
            "IS": "Comau-MP-2500.png",
            "B": "Comau",
            "M": "MP-2500",
            "T": "Ext. axis",
            "A": 1,
            "P": 2500,
            "W": 290,
            "E": 0.09
        },
        "Comau-MP-5000": {
            "MT": "E",
            "N": "Comau MP-5000",
            "F": "Comau-MP-5000.robot",
            "I": "Comau-MP-5000-robot.png",
            "IS": "Comau-MP-5000.png",
            "B": "Comau",
            "M": "MP-5000",
            "T": "Ext. axis",
            "A": 1,
            "P": 5000,
            "W": 2000,
            "E": 0.1
        },
        "Comau-PTS-ORB-1000": {
            "MT": "E",
            "N": "Comau PTS-ORB-1000",
            "F": "Comau-PTS-ORB-1000.robot",
            "I": "Comau-PTS-ORB-1000-robot.png",
            "IS": "Comau-PTS-ORB-1000.png",
            "B": "Comau",
            "M": "PTS-ORB-1000",
            "T": "Ext. axis",
            "A": 2,
            "P": 1000,
            "W": 630,
            "E": 0.06
        },
        "Comau-PTS-ORB-1000-MT": {
            "MT": "E",
            "N": "Comau PTS-ORB-1000-MT",
            "F": "Comau-PTS-ORB-1000-MT.robot",
            "I": "Comau-PTS-ORB-1000-MT-robot.png",
            "IS": "Comau-PTS-ORB-1000-MT.png",
            "B": "Comau",
            "M": "PTS-ORB-1000-MT",
            "T": "Ext. axis",
            "A": 2,
            "P": 1000,
            "W": 630,
            "E": 0.06
        },
        "Comau-RT-1500": {
            "MT": "E",
            "N": "Comau RT-1500",
            "F": "Comau-RT-1500.robot",
            "I": "Comau-RT-1500-robot.png",
            "IS": "Comau-RT-1500.png",
            "B": "Comau",
            "M": "RT-1500",
            "T": "Ext. axis",
            "A": 1,
            "P": 1500
        },
        "Comau-RT-3000": {
            "MT": "E",
            "N": "Comau RT-3000",
            "F": "Comau-RT-3000.robot",
            "I": "Comau-RT-3000-robot.png",
            "IS": "Comau-RT-3000.png",
            "B": "Comau",
            "M": "RT-3000",
            "T": "Ext. axis",
            "A": 1,
            "P": 3000
        },
        "Gudel-FP-1-300": {
            "MT": "E",
            "N": "Gudel FP-1-300",
            "F": "Gudel-FP-1-300.robot",
            "I": "Gudel-FP-1-300-robot.png",
            "IS": "Gudel-FP-1-300.png",
            "B": "Gudel",
            "M": "FP-1-300",
            "T": "Ext. axis",
            "A": 3,
            "R": 4000,
            "P": 2549.3,
            "E": 0.02
        },
        "Gudel-FP-6-300": {
            "MT": "E",
            "N": "Gudel FP-6-300",
            "F": "Gudel-FP-6-300.robot",
            "I": "Gudel-FP-6-300-robot.png",
            "IS": "Gudel-FP-6-300.png",
            "B": "Gudel",
            "M": "FP-6-300",
            "T": "Ext. axis",
            "A": 3,
            "P": 2549.3,
            "E": 0.02
        },
        "Gudel-TMF-1-6m": {
            "MT": "E",
            "N": "Gudel TMF-1 6m",
            "F": "Gudel-TMF-1-6m.robot",
            "I": "Gudel-TMF-1-6m-robot.png",
            "IS": "Gudel-TMF-1-6m.png",
            "B": "Gudel",
            "M": "TMF-1 6m",
            "T": "Ext. axis",
            "A": 1,
            "R": 6400
        },
        "Gudel-TMF-1": {
            "MT": "E",
            "N": "Gudel TMF-1",
            "F": "Gudel-TMF-1.robot",
            "I": "Gudel-TMF-1-robot.png",
            "IS": "Gudel-TMF-1.png",
            "B": "Gudel",
            "M": "TMF-1",
            "T": "Ext. axis",
            "A": 1,
            "R": 11000
        },
        "Gudel-TMF-2-6m": {
            "MT": "E",
            "N": "Gudel TMF-2 6m",
            "F": "Gudel-TMF-2-6m.robot",
            "I": "Gudel-TMF-2-6m-robot.png",
            "IS": "Gudel-TMF-2-6m.png",
            "B": "Gudel",
            "M": "TMF-2 6m",
            "T": "Ext. axis",
            "A": 1,
            "R": 6140
        },
        "Gudel-TMF-2": {
            "MT": "E",
            "N": "Gudel TMF-2",
            "F": "Gudel-TMF-2.robot",
            "I": "Gudel-TMF-2-robot.png",
            "IS": "Gudel-TMF-2.png",
            "B": "Gudel",
            "M": "TMF-2",
            "T": "Ext. axis",
            "A": 1,
            "R": 5100
        },
        "Gudel-TMF-3-10m": {
            "MT": "E",
            "N": "Gudel TMF-3 10m",
            "F": "Gudel-TMF-3-10m.robot",
            "I": "Gudel-TMF-3-10m-robot.png",
            "IS": "Gudel-TMF-3-10m.png",
            "B": "Gudel",
            "M": "TMF-3 10m",
            "T": "Ext. axis",
            "A": 1,
            "R": 10720
        },
        "Gudel-TMF-3": {
            "MT": "E",
            "N": "Gudel TMF-3",
            "F": "Gudel-TMF-3.robot",
            "I": "Gudel-TMF-3-robot.png",
            "IS": "Gudel-TMF-3.png",
            "B": "Gudel",
            "M": "TMF-3",
            "T": "Ext. axis",
            "A": 1,
            "R": 7500
        },
        "Gudel-TMF-4-15m": {
            "MT": "E",
            "N": "Gudel TMF-4 15m",
            "F": "Gudel-TMF-4-15m.robot",
            "I": "Gudel-TMF-4-15m-robot.png",
            "IS": "Gudel-TMF-4-15m.png",
            "B": "Gudel",
            "M": "TMF-4 15m",
            "T": "Ext. axis",
            "A": 1,
            "R": 15450
        },
        "Gudel-TMF-4": {
            "MT": "E",
            "N": "Gudel TMF-4",
            "F": "Gudel-TMF-4.robot",
            "I": "Gudel-TMF-4-robot.png",
            "IS": "Gudel-TMF-4.png",
            "B": "Gudel",
            "M": "TMF-4",
            "T": "Ext. axis",
            "A": 1,
            "R": 8400
        },
        "Gudel-TMF-5-20m": {
            "MT": "E",
            "N": "Gudel TMF-5 20m",
            "F": "Gudel-TMF-5-20m.robot",
            "I": "Gudel-TMF-5-20m-robot.png",
            "IS": "Gudel-TMF-5-20m.png",
            "B": "Gudel",
            "M": "TMF-5 20m",
            "T": "Ext. axis",
            "A": 1,
            "R": 20000
        },
        "Gudel-TMF-5": {
            "MT": "E",
            "N": "Gudel TMF-5",
            "F": "Gudel-TMF-5.robot",
            "I": "Gudel-TMF-5-robot.png",
            "IS": "Gudel-TMF-5.png",
            "B": "Gudel",
            "M": "TMF-5",
            "T": "Ext. axis",
            "A": 1,
            "R": 9000
        },
        "HIWIN-HT200B": {
            "MT": "E",
            "N": "HIWIN HT200B",
            "F": "HIWIN-HT200B.robot",
            "I": "HIWIN-HT200B-robot.png",
            "IS": "HIWIN-HT200B.png",
            "B": "HIWIN",
            "M": "HT200B",
            "T": "Ext. axis",
            "A": 1,
            "R": 5000,
            "P": 150
        },
        "HIWIN-HT200S": {
            "MT": "E",
            "N": "HIWIN HT200S",
            "F": "HIWIN-HT200S.robot",
            "I": "HIWIN-HT200S-robot.png",
            "IS": "HIWIN-HT200S.png",
            "B": "HIWIN",
            "M": "HT200S",
            "T": "Ext. axis",
            "A": 1,
            "R": 5000,
            "P": 150
        },
        "HIWIN-HT250B": {
            "MT": "E",
            "N": "HIWIN HT250B",
            "F": "HIWIN-HT250B.robot",
            "I": "HIWIN-HT250B-robot.png",
            "IS": "HIWIN-HT250B.png",
            "B": "HIWIN",
            "M": "HT250B",
            "T": "Ext. axis",
            "A": 1,
            "R": 5000,
            "P": 250
        },
        "HIWIN-HT250S": {
            "MT": "E",
            "N": "HIWIN HT250S",
            "F": "HIWIN-HT250S.robot",
            "I": "HIWIN-HT250S-robot.png",
            "IS": "HIWIN-HT250S.png",
            "B": "HIWIN",
            "M": "HT250S",
            "T": "Ext. axis",
            "A": 1,
            "R": 4800,
            "P": 250
        },
        "KUKA-DKP-400": {
            "MT": "E",
            "N": "KUKA DKP 400",
            "F": "KUKA-DKP-400.robot",
            "I": "KUKA-DKP-400-robot.png",
            "IS": "KUKA-DKP-400.png",
            "B": "KUKA",
            "M": "DKP 400",
            "T": "Ext. axis",
            "A": 2,
            "P": 400
        },
        "KUKA-KL-250-3": {
            "MT": "E",
            "N": "KUKA KL 250 3",
            "F": "KUKA-KL-250-3.robot",
            "I": "KUKA-KL-250-3-robot.png",
            "IS": "KUKA-KL-250-3.png",
            "B": "KUKA",
            "M": "KL 250 3",
            "T": "Ext. axis",
            "A": 1,
            "R": 3600,
            "P": 300,
            "E": 0.02
        },
        "KUKA-KL-1000-2": {
            "MT": "E",
            "N": "KUKA KL 1000 2",
            "F": "KUKA-KL-1000-2.robot",
            "I": "KUKA-KL-1000-2-robot.png",
            "IS": "KUKA-KL-1000-2.png",
            "B": "KUKA",
            "M": "KL 1000 2",
            "T": "Ext. axis",
            "A": 1,
            "R": 1200,
            "P": 1000,
            "E": 0.02
        },
        "KUKA-KL-1500-3": {
            "MT": "E",
            "N": "KUKA KL 1500 3",
            "F": "KUKA-KL-1500-3.robot",
            "I": "KUKA-KL-1500-3-robot.png",
            "IS": "KUKA-KL-1500-3.png",
            "B": "KUKA",
            "M": "KL 1500 3",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 2000,
            "E": 0.02
        },
        "KUKA-KL-2000-SP": {
            "MT": "E",
            "N": "KUKA KL 2000 SP",
            "F": "KUKA-KL-2000-SP.robot",
            "I": "KUKA-KL-2000-SP-robot.png",
            "IS": "KUKA-KL-2000-SP.png",
            "B": "KUKA",
            "M": "KL 2000 SP",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 2000,
            "E": 0.02
        },
        "KUKA-KL-2000": {
            "MT": "E",
            "N": "KUKA KL 2000",
            "F": "KUKA-KL-2000.robot",
            "I": "KUKA-KL-2000-robot.png",
            "IS": "KUKA-KL-2000.png",
            "B": "KUKA",
            "M": "KL 2000",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 2000,
            "E": 0.02
        },
        "KUKA-KL-3000": {
            "MT": "E",
            "N": "KUKA KL 3000",
            "F": "KUKA-KL-3000.robot",
            "I": "KUKA-KL-3000-robot.png",
            "IS": "KUKA-KL-3000.png",
            "B": "KUKA",
            "M": "KL 3000",
            "T": "Ext. axis",
            "A": 1,
            "R": 3300,
            "P": 6500,
            "E": 0.02
        },
        "KUKA-KL-4000-4m": {
            "MT": "E",
            "N": "KUKA KL 4000 4m",
            "F": "KUKA-KL-4000-4m.robot",
            "I": "KUKA-KL-4000-4m-robot.png",
            "IS": "KUKA-KL-4000-4m.png",
            "B": "KUKA",
            "M": "KL 4000 4m",
            "T": "Ext. axis",
            "A": 1,
            "R": 4000,
            "P": 4000,
            "E": 0.02
        },
        "KUKA-KL-4000-12-4m": {
            "MT": "E",
            "N": "KUKA KL 4000 12.4m",
            "F": "KUKA-KL-4000-12-4m.robot",
            "I": "KUKA-KL-4000-12-4m-robot.png",
            "IS": "KUKA-KL-4000-12-4m.png",
            "B": "KUKA",
            "M": "KL 4000 12.4m",
            "T": "Ext. axis",
            "A": 1,
            "R": 12400,
            "P": 4000,
            "E": 0.02
        },
        "KUKA-KP1-H250-EH980": {
            "MT": "E",
            "N": "KUKA KP1 H250 EH980",
            "F": "KUKA-KP1-H250-EH980.robot",
            "I": "KUKA-KP1-H250-EH980-robot.png",
            "IS": "KUKA-KP1-H250-EH980.png",
            "B": "KUKA",
            "M": "KP1 H250 EH980",
            "T": "Ext. axis",
            "A": 1,
            "P": 250
        },
        "KUKA-KP1-H250-EH1280": {
            "MT": "E",
            "N": "KUKA KP1 H250 EH1280",
            "F": "KUKA-KP1-H250-EH1280.robot",
            "I": "KUKA-KP1-H250-EH1280-robot.png",
            "IS": "KUKA-KP1-H250-EH1280.png",
            "B": "KUKA",
            "M": "KP1 H250 EH1280",
            "T": "Ext. axis",
            "A": 1,
            "P": 250
        },
        "KUKA-KP1-H1000-EH980": {
            "MT": "E",
            "N": "KUKA KP1 H1000 EH980",
            "F": "KUKA-KP1-H1000-EH980.robot",
            "I": "KUKA-KP1-H1000-EH980-robot.png",
            "IS": "KUKA-KP1-H1000-EH980.png",
            "B": "KUKA",
            "M": "KP1 H1000 EH980",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000
        },
        "KUKA-KP1-H1000-EH1280": {
            "MT": "E",
            "N": "KUKA KP1 H1000 EH1280",
            "F": "KUKA-KP1-H1000-EH1280.robot",
            "I": "KUKA-KP1-H1000-EH1280-robot.png",
            "IS": "KUKA-KP1-H1000-EH1280.png",
            "B": "KUKA",
            "M": "KP1 H1000 EH1280",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000
        },
        "KUKA-KP1-MD250": {
            "MT": "E",
            "N": "KUKA KP1 MD250",
            "F": "KUKA-KP1-MD250.robot",
            "I": "KUKA-KP1-MD250-robot.png",
            "IS": "KUKA-KP1-MD250.png",
            "B": "KUKA",
            "M": "KP1 MD250",
            "T": "Ext. axis",
            "A": 1,
            "P": 250
        },
        "KUKA-KP1-MD500": {
            "MT": "E",
            "N": "KUKA KP1 MD500",
            "F": "KUKA-KP1-MD500.robot",
            "I": "KUKA-KP1-MD500-robot.png",
            "IS": "KUKA-KP1-MD500.png",
            "B": "KUKA",
            "M": "KP1 MD500",
            "T": "Ext. axis",
            "A": 1,
            "P": 500
        },
        "KUKA-KP1-MD750": {
            "MT": "E",
            "N": "KUKA KP1 MD750",
            "F": "KUKA-KP1-MD750.robot",
            "I": "KUKA-KP1-MD750-robot.png",
            "IS": "KUKA-KP1-MD750.png",
            "B": "KUKA",
            "M": "KP1 MD750",
            "T": "Ext. axis",
            "A": 1,
            "P": 750
        },
        "KUKA-KP1-MD1000": {
            "MT": "E",
            "N": "KUKA KP1 MD1000",
            "F": "KUKA-KP1-MD1000.robot",
            "I": "KUKA-KP1-MD1000-robot.png",
            "IS": "KUKA-KP1-MD1000.png",
            "B": "KUKA",
            "M": "KP1 MD1000",
            "T": "Ext. axis",
            "A": 1,
            "P": 1000
        },
        "KUKA-KP1-V-500": {
            "MT": "E",
            "N": "KUKA KP1-V 500",
            "F": "KUKA-KP1-V-500.robot",
            "I": "KUKA-KP1-V-500-robot.png",
            "IS": "KUKA-KP1-V-500.png",
            "B": "KUKA",
            "M": "KP1-V 500",
            "T": "Ext. axis",
            "A": 1,
            "P": 500
        },
        "KUKA-KP2-HV500": {
            "MT": "E",
            "N": "KUKA KP2-HV500",
            "F": "KUKA-KP2-HV500.robot",
            "I": "KUKA-KP2-HV500-robot.png",
            "IS": "KUKA-KP2-HV500.png",
            "B": "KUKA",
            "M": "KP2-HV500",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "W": 445
        },
        "KUKA-KP2-SV2600-HW": {
            "MT": "E",
            "N": "KUKA KP2-SV2600 HW",
            "F": "KUKA-KP2-SV2600-HW.robot",
            "I": "KUKA-KP2-SV2600-HW-robot.png",
            "IS": "KUKA-KP2-SV2600-HW.png",
            "B": "KUKA",
            "M": "KP2-SV2600 HW",
            "T": "Ext. axis",
            "A": 2,
            "P": 2600,
            "W": 6440
        },
        "KUKA-KPF1-V500-V1": {
            "MT": "E",
            "N": "KUKA KPF1 V500 V1",
            "F": "KUKA-KPF1-V500-V1.robot",
            "I": "KUKA-KPF1-V500-V1-robot.png",
            "IS": "KUKA-KPF1-V500-V1.png",
            "B": "KUKA",
            "M": "KPF1 V500 V1",
            "T": "Ext. axis",
            "A": 1,
            "P": 500
        },
        "Lucas-ALIS-1R": {
            "MT": "E",
            "N": "Lucas ALIS-1R",
            "F": "Lucas-ALIS-1R.robot",
            "I": "Lucas-ALIS-1R-robot.png",
            "IS": "Lucas-ALIS-1R.png",
            "B": "Lucas",
            "M": "ALIS-1R",
            "T": "Ext. axis",
            "A": 1,
            "R": 10230
        },
        "Lucas-ALSS-1R": {
            "MT": "E",
            "N": "Lucas ALSS-1R",
            "F": "Lucas-ALSS-1R.robot",
            "I": "Lucas-ALSS-1R-robot.png",
            "IS": "Lucas-ALSS-1R.png",
            "B": "Lucas",
            "M": "ALSS-1R",
            "T": "Ext. axis",
            "A": 1,
            "R": 5230
        },
        "Lucas-RC2-YZ-1R": {
            "MT": "E",
            "N": "Lucas RC2-YZ-1R",
            "F": "Lucas-RC2-YZ-1R.robot",
            "I": "Lucas-RC2-YZ-1R-robot.png",
            "IS": "Lucas-RC2-YZ-1R.png",
            "B": "Lucas",
            "M": "RC2-YZ-1R",
            "T": "Ext. axis",
            "A": 2,
            "R": 10150
        },
        "Lucas-RC3-1Y1R": {
            "MT": "E",
            "N": "Lucas RC3-1Y1R",
            "F": "Lucas-RC3-1Y1R.robot",
            "I": "Lucas-RC3-1Y1R-robot.png",
            "IS": "Lucas-RC3-1Y1R.png",
            "B": "Lucas",
            "M": "RC3-1Y1R",
            "T": "Ext. axis",
            "A": 3,
            "R": 7750
        },
        "MABI-Robotic-MLR-2500-P": {
            "MT": "E",
            "N": "MABI Robotic MLR-2500-P",
            "F": "MABI-Robotic-MLR-2500-P.robot",
            "I": "MABI-Robotic-MLR-2500-P-robot.png",
            "IS": "MABI-Robotic-MLR-2500-P.png",
            "B": "MABI Robotic",
            "M": "MLR-2500-P",
            "T": "Ext. axis",
            "A": 1,
            "R": 3500,
            "P": 2500,
            "E": 4.1e-05
        },
        "MABI-Robotic-MMT-650-500-DD": {
            "MT": "E",
            "N": "MABI Robotic MMT-650-500-DD",
            "F": "MABI-Robotic-MMT-650-500-DD.robot",
            "I": "MABI-Robotic-MMT-650-500-DD-robot.png",
            "IS": "MABI-Robotic-MMT-650-500-DD.png",
            "B": "MABI Robotic",
            "M": "MMT-650-500-DD",
            "T": "Ext. axis",
            "A": 2,
            "P": 500
        },
        "SMC-500AG": {
            "MT": "E",
            "N": "SMC 500AG",
            "F": "SMC-500AG.robot",
            "I": "SMC-500AG-robot.png",
            "IS": "SMC-500AG.png",
            "B": "SMC",
            "M": "500AG",
            "T": "Ext. axis",
            "A": 1
        },
        "SMC-600AG": {
            "MT": "E",
            "N": "SMC 600AG",
            "F": "SMC-600AG.robot",
            "I": "SMC-600AG-robot.png",
            "IS": "SMC-600AG.png",
            "B": "SMC",
            "M": "600AG",
            "T": "Ext. axis",
            "A": 1
        },
        "Vansichen-FT45-S6000": {
            "MT": "E",
            "N": "Vansichen FT45 S6000",
            "F": "Vansichen-FT45-S6000.robot",
            "I": "Vansichen-FT45-S6000-robot.png",
            "IS": "Vansichen-FT45-S6000.png",
            "B": "Vansichen",
            "M": "FT45 S6000",
            "T": "Ext. axis",
            "A": 1,
            "R": 6000,
            "P": 1500
        },
        "Motoman-MOTOPOS-D250F": {
            "MT": "E",
            "N": "Motoman MOTOPOS-D250F",
            "F": "Motoman-MOTOPOS-D250F.robot",
            "I": "Motoman-MOTOPOS-D250F-robot.png",
            "IS": "Motoman-MOTOPOS-D250F.png",
            "B": "Yaskawa Motoman",
            "M": "MOTOPOS-D250F",
            "T": "Ext. axis",
            "A": 2,
            "P": 250,
            "W": 265,
            "E": 0.08
        },
        "Motoman-MSR-355": {
            "MT": "E",
            "N": "Motoman MSR-355",
            "F": "Motoman-MSR-355.robot",
            "I": "Motoman-MSR-355-robot.png",
            "IS": "Motoman-MSR-355.png",
            "B": "Yaskawa Motoman",
            "M": "MSR-355",
            "T": "Ext. axis",
            "A": 1,
            "P": 355
        },
        "Motoman-MT1-500-S2HD": {
            "MT": "E",
            "N": "Motoman MT1-500 S2HD",
            "F": "Motoman-MT1-500-S2HD.robot",
            "I": "Motoman-MT1-500-S2HD-robot.png",
            "IS": "Motoman-MT1-500-S2HD.png",
            "B": "Yaskawa Motoman",
            "M": "MT1-500 S2HD",
            "T": "Ext. axis",
            "A": 2,
            "P": 500,
            "E": 0.1
        },
        "Zaber-LRQ450xL-E01CT3A": {
            "MT": "E",
            "N": "Zaber LRQ450xL-E01CT3A",
            "F": "Zaber-LRQ450xL-E01CT3A.robot",
            "I": "Zaber-LRQ450xL-E01CT3A-robot.png",
            "IS": "Zaber-LRQ450xL-E01CT3A.png",
            "B": "Zaber",
            "M": "LRQ450xL-E01CT3A",
            "T": "Ext. axis",
            "A": 1,
            "R": 450,
            "P": 100,
            "E": 0.003
        },
        "Zaber-LRQ600xL-E01CT3A": {
            "MT": "E",
            "N": "Zaber LRQ600xL-E01CT3A",
            "F": "Zaber-LRQ600xL-E01CT3A.robot",
            "I": "Zaber-LRQ600xL-E01CT3A-robot.png",
            "IS": "Zaber-LRQ600xL-E01CT3A.png",
            "B": "Zaber",
            "M": "LRQ600xL-E01CT3A",
            "T": "Ext. axis",
            "A": 1,
            "R": 600,
            "P": 100,
            "E": 0.003
        },
        "Zaber-LRQ600xP-E01CT3A": {
            "MT": "E",
            "N": "Zaber LRQ600xP-E01CT3A",
            "F": "Zaber-LRQ600xP-E01CT3A.robot",
            "I": "Zaber-LRQ600xP-E01CT3A-robot.png",
            "IS": "Zaber-LRQ600xP-E01CT3A.png",
            "B": "Zaber",
            "M": "LRQ600xP-E01CT3A",
            "T": "Ext. axis",
            "A": 1,
            "R": 600,
            "P": 100,
            "E": 0.003
        },
        "Zaber-LRU1000x18-E01T11A": {
            "MT": "E",
            "N": "Zaber LRU1000x18-E01T11A",
            "F": "Zaber-LRU1000x18-E01T11A.robot",
            "I": "Zaber-LRU1000x18-E01T11A-robot.png",
            "IS": "Zaber-LRU1000x18-E01T11A.png",
            "B": "Zaber",
            "M": "LRU1000x18-E01T11A",
            "T": "Ext. axis",
            "A": 1,
            "R": 1000,
            "P": 500,
            "E": 0.003
        },
        "Zaber-LRU1500x18-E01T11A": {
            "MT": "E",
            "N": "Zaber LRU1500x18-E01T11A",
            "F": "Zaber-LRU1500x18-E01T11A.robot",
            "I": "Zaber-LRU1500x18-E01T11A-robot.png",
            "IS": "Zaber-LRU1500x18-E01T11A.png",
            "B": "Zaber",
            "M": "LRU1500x18-E01T11A",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 500,
            "E": 0.003
        },
        "Zaber-LRU1500x25-E01T11A": {
            "MT": "E",
            "N": "Zaber LRU1500x25-E01T11A",
            "F": "Zaber-LRU1500x25-E01T11A.robot",
            "I": "Zaber-LRU1500x25-E01T11A-robot.png",
            "IS": "Zaber-LRU1500x25-E01T11A.png",
            "B": "Zaber",
            "M": "LRU1500x25-E01T11A",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 500,
            "E": 0.003
        },
        "Zaber-LRU2000x25-E01T11A": {
            "MT": "E",
            "N": "Zaber LRU2000x25-E01T11A",
            "F": "Zaber-LRU2000x25-E01T11A.robot",
            "I": "Zaber-LRU2000x25-E01T11A-robot.png",
            "IS": "Zaber-LRU2000x25-E01T11A.png",
            "B": "Zaber",
            "M": "LRU2000x25-E01T11A",
            "T": "Ext. axis",
            "A": 1,
            "R": 2000,
            "P": 500,
            "E": 0.003
        },
        "Zaber-RST120AK-E03T3A": {
            "MT": "E",
            "N": "Zaber RST120AK-E03T3A",
            "F": "Zaber-RST120AK-E03T3A.robot",
            "I": "Zaber-RST120AK-E03T3A-robot.png",
            "IS": "Zaber-RST120AK-E03T3A.png",
            "B": "Zaber",
            "M": "RST120AK-E03T3A",
            "T": "Ext. axis",
            "A": 1,
            "P": 50
        },
        "Zaber-RST240B-E08T3A": {
            "MT": "E",
            "N": "Zaber RST240B-E08T3A",
            "F": "Zaber-RST240B-E08T3A.robot",
            "I": "Zaber-RST240B-E08T3A-robot.png",
            "IS": "Zaber-RST240B-E08T3A.png",
            "B": "Zaber",
            "M": "RST240B-E08T3A",
            "T": "Ext. axis",
            "A": 1,
            "P": 300
        },
        "Zaber-X-LRT0750xL-AE53C": {
            "MT": "E",
            "N": "Zaber X-LRT0750xL-AE53C",
            "F": "Zaber-X-LRT0750xL-AE53C.robot",
            "I": "Zaber-X-LRT0750xL-AE53C-robot.png",
            "IS": "Zaber-X-LRT0750xL-AE53C.png",
            "B": "Zaber",
            "M": "X-LRT0750xL-AE53C",
            "T": "Ext. axis",
            "A": 1,
            "R": 750,
            "P": 300,
            "E": 0.002
        },
        "Zaber-X-LRT1000xL-AE53C": {
            "MT": "E",
            "N": "Zaber X-LRT1000xL-AE53C",
            "F": "Zaber-X-LRT1000xL-AE53C.robot",
            "I": "Zaber-X-LRT1000xL-AE53C-robot.png",
            "IS": "Zaber-X-LRT1000xL-AE53C.png",
            "B": "Zaber",
            "M": "X-LRT1000xL-AE53C",
            "T": "Ext. axis",
            "A": 1,
            "R": 1000,
            "P": 300,
            "E": 0.002
        },
        "Zaber-X-LRT1500xL-AE53C": {
            "MT": "E",
            "N": "Zaber X-LRT1500xL-AE53C",
            "F": "Zaber-X-LRT1500xL-AE53C.robot",
            "I": "Zaber-X-LRT1500xL-AE53C-robot.png",
            "IS": "Zaber-X-LRT1500xL-AE53C.png",
            "B": "Zaber",
            "M": "X-LRT1500xL-AE53C",
            "T": "Ext. axis",
            "A": 1,
            "R": 1500,
            "P": 300,
            "E": 0.002
        }
    }
}